import { getFormatMessage, getReqMessage } from '../../../utils/formValidation/errorMessageFunctions';
import {
    validateContractId,
    validateEmail,
    validatePhone,
    validatePostcode,
    validateServiceId,
    validateTeamId,
    validateUniqueIdentifier
} from '../../../utils/formValidation/validationFunctions';
import {
    validateFirstName,
    validateLastName,
    validateMiddleName,
    validateReferralDate
} from '../validation/validationFunctions';

const getErrorState = (message) => ({ error: true, message });

export const getPostcodeInputErrors = (postcode, prevErrors = {}) => {
    if (!postcode || validatePostcode(postcode, {}).postcode === undefined) {
        if (!('postcode' in prevErrors)) return prevErrors;
        return {
            ...prevErrors,
            postcode: { error: false, message: '' }
        };
    }

    return {
        ...prevErrors,
        postcode: getErrorState(getFormatMessage('Postcode'))
    };
};

export const getSubmitErrors = (newEntry) =>
    validate(newEntry);

export const validate = (newEntry) => {
    let newErrors = {};

    newErrors = validateContractId(newEntry.contractId, newErrors);
    newErrors = validateServiceId(newEntry.serviceId, newErrors);
    newErrors = validateTeamId(newEntry.teamId, newErrors);
    newErrors = validateReferralDate(newEntry.referralDate, newErrors);
    newErrors = validateFirstName(newEntry.firstName, newErrors);
    newErrors = validateMiddleName(newEntry.middleName, newErrors);
    newErrors = validateLastName(newEntry.lastName, newErrors);
    if (!newEntry.postcode) {
        newErrors = {
            ...newErrors,
            postcode: getErrorState(getReqMessage('Postcode'))
        };
    } else newErrors = validatePostcode(newEntry.postcode, newErrors);
    newErrors = validatePhone(newEntry.primaryPhoneNumber, newErrors, 'primaryPhoneNumber');
    newErrors = validateEmail(newEntry.emailAddress, newErrors);

    if (newEntry.contractId) {
        newErrors = validateUniqueIdentifier(
            newEntry.uniqueIdentifierType,
            newEntry.uniqueIdentifier,
            newEntry.repeatUniqueIdentifier,
            newErrors
        );
    }

    return newErrors;
};
